module.exports = __webpack_public_path__ + "assets/img/20210924-2.78f1fde6.png";